<template>
  <router-view v-slot="{ Component, route }">
  <keep-alive :include="keepAliveInclude" :max="10">
    <component v-if="Component" :is="Component" :key="route.name" @beforeUnmount="onBeforeUnmount" />
  </keep-alive>
</router-view>

</template>

<script>
// .el-cascader .el-input.is-focus .el-input__wrapper{
//     box-shadow:none !important;
// }
export default {
  name: "App",
  components: {},
  computed: {
    keepAliveInclude() {
      // 获取路由中定义的meta.keepAlive 为true 的所有路由的组件名称
      const keepAliveInclude = this.$router.options.routes
        .filter((route) => route.meta && route.meta.keepAlive)
        .map((route) => route.name);
      return keepAliveInclude;
    },
  },
  mounted() {

  }
};
</script>
<style lang="scss">

.el-box .el-select .el-input.is-focus .el-input__wrapper {
  box-shadow: 0 0 0 1px #a0a8c4 inset !important;
}
#flatDate .flatpickr-input {
  color: #ffffff97 !important;
  background: #ffffff00 !important;
}
//.el-cascader-node {
//  align-items: flex-start !important;
//}

.el-tag {
  background: #405189 !important;
  color: #fff !important;
}
.el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #405189 !important;
  background-color: #405189 !important;
}
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #221f1fc0 !important;
}
.el-input__wrapper {
  padding: 2.5px 11px !important ;
}
.select_input .el-select .el-input.is-focus .el-input__wrapper {
  box-shadow: 0 0 0 0 #ffffff00 !important;
}
.select_input .el-select .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 0 #ffffff00 !important;
}
.select_input .el-select .el-select__wrapper.is-focus {
  box-shadow: 0 0 0 0 #ffffff00 !important;
}
.select_input .el-select:hover:not(.el-select--disabled) .el-input__wrapper {
  box-shadow: 0 0 0 0 #ffffff00 !important;
}
.select_input .el-select:hover:not(.el-select--disabled) .el-select__wrapper {
  box-shadow: 0 0 0 0 #ffffff00 !important;
}
// .select_input .el-select__wrapper{
//   width: 180px !important;
//   background-color: none !important; 
//      border-radius: none !important; 
//     box-shadow:none !important;
// }
.select_input .el-select__wrapper{
  width: 180px !important;
}
.select_popper {
  background: rgba(49, 58, 91, 0.99) !important;
  box-shadow: 0 14px 20px 0 rgba(42, 51, 83, 0.8) !important;
  backdrop-filter: blur(10px) !important;
  border: none !important;
  color: #ffffff !important;
}
.select_popper .el-select-dropdown__item {
  color: #ffffff !important;
}
.select_popper .el-popper__arrow {
  display: none !important;
}
.select_popper .el-cascader-node__label {
  color: #ffffff !important;
}
.select_popper .is-active .el-cascader-node__label {
  color: #7abdff !important;
}
.select_popper .el-checkbox .el-checkbox__inner {
  background-color: #7abcff00 !important;
}
.select_popper .el-cascader-node__postfix {
  top: 10px;
}
.select_popper .el-cascader-node:not(.is-disabled):focus,
.el-cascader-node:not(.is-disabled):hover {
  color: #7abdff !important;
  background: none !important;
}
.select_popper .el-cascader-node:not(.is-disabled):focus,
.el-cascader-node:not(.is-disabled):hover .el-cascader-node__label {
  color: #7abdff !important;
}
.select_popper .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #7abdff !important;
}
.select_input{
    .el-input__wrapper,
    .el-select__wrapper,
    .el-select,
    .el-input,
    .is-focus,
    .el-input__inner {
    background: rgba(21, 43, 94, 0) !important;

    color: #b6b7bc99 !important;

    border: none !important;
    box-shadow: none !important;

    border-radius: 0px !important;

    text-align: center !important;
    }
    .el-select-dropdown__item.is-hovering{
      background-color: #7abdff !important;
    }
}
.custom-class .el-input__icon{
  display: none !important;
}
.custom-class .el-input__wrapper{
  padding: 0px !important ;

    justify-content: start !important;
}
.custom-class .el-date-editor .el-range-separator{
  padding: 0px !important ;
  flex: 0 !important ;
  color: #606266 !important ;

}
:deep(.amap-logo){
    display: none !important;
}
:deep(.amap-copyright){
    opacity:0!important;
}

.top-auto-complete>.el-input .el-input__wrapper {
  background: #00000000 !important;
  border-radius: 4px !important;
}
.top-auto-complete>.el-popper.is-light{
  background: #00000000 !important;
}

.top-auto-complete>.el-popper__arrow{
  display: none !important;
}
.accordion-button-class .form-check input[type="checkbox"]:checked:after {

  background-color: transparent !important;

}
.accordion-button-class input[type="checkbox"]:checked:after {

  background-color: transparent !important;

}
::-webkit-scrollbar-thumb{
  background-color: rgb(125, 125, 125) !important;
}
.el-popper{
  z-index: 9999 !important;
}
.el-radio__input.is-checked .el-radio__inner{
  border-color: #405189 !important;
  background: #405189 !important;
}
.el-radio__input.is-checked+.el-radio__label{
  color: #405189 !important;
}
/* 设置背景色 */
.packageDownLoad-tooltip {
  background-color: #2267EE !important;
}
/* 设置箭头颜色 */
.packageDownLoad-tooltip>.el-popper__arrow:before{
  background-color: #2267EE !important;
  border:1px solid #2267EE !important;
}
.report-class>.card-body{
  padding: 0 !important;
}
.el-tabs__content{
  width: 100% !important;
}
.topTabsButton .el-tabs__new-tab{
  display: inline-block !important;
  width: 115px !important;
  margin-right: 20px !important;
  height: 38px !important;
  margin-top: 0 !important;
  border: none !important;
}
.el-table .DisableSelection .cell .el-checkbox__inner{
  display: none !important;
}
.table-card th:first-child, .table-card td:first-child{
  padding-left:0.6rem !important;
}
.el-tabs__item{
  font-size: 13px !important;
}
.el-progress__text{
  font-size: 14px !important;
}
.el-form-item__label {
    justify-content:flex-start !important;
}
.modal-page-custom{
  .el-input__inner{
  text-align:center !important;
}
}

</style>


